<!--
 * @Author: zb
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:57
 * @LastEditTime: 2019-09-30 15:28:19
 * @Version: 1.0
 * @Description: 运力详情显示页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <div class="transport-item-details">
    <div class="base-info">
      <div>基本信息</div>
      <div class="info-detail">
        <div class="detail-item">
          <div style="color: rgb(92,162,62)">
            <span>起运地</span>
            {{ transport.startPlaceProvince + transport.startPlaceLabel }}
          </div>
          <div>
            <span>详细地址</span>
            {{ transport.startPlaceDetail }}
          </div>
        </div>
        <div class="detail-item">
          <div style="color: rgb(196,56,62)">
            <span>目的地</span>
            {{ transport.stopPlaceProvince + transport.stopPlaceLabel }}
          </div>
          <div>
            <span>详细地址</span>
            {{ transport.stopPlaceDetail }}
          </div>
        </div>
        <div class="detail-item">
          <div>
            <span>公司名称</span>
            {{ transport.companyName }}
          </div>
          <div>
            <span>运输品类</span>
            {{ transport.goodsTypeLabel }}
          </div>
          <div>
            <span>承载能力</span>
            {{ transport.weight }}吨
          </div>
        </div>
        <div data-v-523ec6e8 class="detail-item">
          <div style="width: 50%">
            <span>运输方式</span>
            {{ transport.transportTypeLabel }}
          </div>
        </div>
        <div class="detail-item">
          <div>
            <span>起运时间</span>
            {{ transport.earliestTime }}
          </div>
          <div>
            <span>结束时间</span>
            {{ transport.latestTime }}
          </div>
        </div>
      </div>
    </div>
    <div class="contact-info">
      <div>联系人信息</div>
      <ul>
        <li>
          <span>联系人</span>
          {{ transport.shipmentName }}
        </li>
        <li>
          <span>联系电话</span>
          {{ transport.shipmentTel }}
        </li>
      </ul>
    </div>
    <div class="imgs-info">
      <div>运力图片</div>
      <ul>
        <li v-for="(url, index) of transport.fileUrl" :key="index">
          <div v-viewer>
            <img :src="url|getImg">
          </div>
        </li>
      </ul>
      <div>备注</div>
      <span>{{ transport.remarks }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TransportFullInfo',
  props: {
    transport: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$perfix: "transport-item";
$main-color: rgb(190, 35, 22);
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.#{$perfix}-details {
  width: 100%;
  background-color: rgb(250, 251, 255);
  transition: all 0.8s ease-in-out;
  z-index: -1;
  padding-bottom: 16px;
  display: block;
  animation: show 0.8s ease-in-out;
  clip: rect(0 auto 0 0);
  font-size: 14px;
  border: 1px solid #ebeef5;
  > div {
    padding: 16px 16px;
    width: calc(100% - 32px);
    font-size: 14px;
    border-bottom: 1px solid #ebeef5;
    &:last-child {
      border-bottom: none !important;
    }

    ul {
      li {
        span:after {
          content: " : ";
        }
      }
    }

    > div {
      font-size: 14px;
      font-weight: bold;
      color: $main-color;
      margin-bottom: 24px;
    }
    &.base-info {
      span:after {
        content: " : ";
      }
      .info-detail {
        display: flex;
        flex-direction: column;
        color: #000000;
        font-weight: normal;
        margin-bottom: 0;
        .detail-item {
          // display: flex;
          // margin-bottom: 24px;
          min-height: 45px;
          font-size: 14px;
          font-weight: 400;
          line-height: 14px;
          padding: 10px 0px;
          box-sizing: border-box;
          color: #333;
          > div {
            display: inline-block;
            padding: 10px 0;
            &:first-child {
              width: 300px;
            }
          }

          &:nth-child(3) {
            > div {
              &:nth-child(2) {
                width: 285px;
              }
              &:nth-child(3) {
                width: 200px;
              }
              &:last-child {
                display: inline;
                line-height: 24px;
              }
            }
          }
        }
      }
    }

    &.contact-info {
      ul {
        width: 100%;
        display: flex;
        // columns: 2;
        // column-width: 25%;
        // column-gap: 16px;
        > li {
          height: 16px;
          line-height: 16px;
          padding: 4px 0px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          &:first-child {
            width: 300px;
          }
        }
      }
    }

    &.imgs-info {
      ul {
        display: inline-block;
        li {
          float: left;
          margin-right: 24px;
          margin-bottom: 12px;
          &:last-child {
            margin-right: 0px !important;
          }
          img {
            height: 124px;
            width: 136px;
          }
        }
      }
    }
  }
}
</style>
